module.exports = __webpack_public_path__ + "img/banner13.cbf87160.png";